import { render, staticRenderFns } from "./FixedButtonWidget.vue?vue&type=template&id=60aa95cd&scoped=true&"
import script from "./FixedButtonWidget.vue?vue&type=script&lang=js&"
export * from "./FixedButtonWidget.vue?vue&type=script&lang=js&"
import style0 from "./FixedButtonWidget.vue?vue&type=style&index=0&id=60aa95cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa95cd",
  null
  
)

export default component.exports